import styles from "../WorkoutAdminModal.module.css";
import Badge from "./Badge";

function formatDate(iso) {
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  return `${d}/${m}/${y}`;
}

/** "6 semanas", "1 semana", "4 dias" entre o início e o fim (ou hoje). */
export function formatDuration(startIso, endIso, today = new Date()) {
  const start = new Date(`${startIso}T00:00:00`);
  const end = endIso ? new Date(`${endIso}T00:00:00`) : new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const daysCount = Math.max(1, Math.round((end - start) / 86400000) + 1);
  if (daysCount < 14) return `${daysCount} ${daysCount === 1 ? "dia" : "dias"}`;
  const weeks = Math.round(daysCount / 7);
  return `${weeks} semanas`;
}

/** Card "Histórico de programas": quais métodos o aluno já fez e quando. */
export default function StudentProgramHistory({ history }) {
  if (!history.length) return null;
  return (
    <div className={styles.cardGlass}>
      <div className={styles.sectionHead}>
        <div className={styles.sectionHeadLeft}>
          <h4>Histórico de programas</h4>
          <p className={styles.sectionHint}>Os métodos que o aluno já fez, do mais recente para o mais antigo.</p>
        </div>
        <Badge tone="soft">{history.length}</Badge>
      </div>
      <ul className={`${styles.planItemList} ${styles.programHistoryList}`}>
        {history.map((h) => (
          <li key={h.id} className={styles.planItemRow}>
            <div className={styles.planItemRowMain}>
              <div className={styles.planItemTitle}>{h.program_name}</div>
              <div className={styles.planItemMeta}>
                {h.in_progress
                  ? <Badge tone="success">Em andamento</Badge>
                  : <Badge tone="muted">Encerrado</Badge>}
                {h.program_method && <Badge tone="info">{h.program_method}</Badge>}
                <span>
                  {h.ended_on
                    ? `${formatDate(h.started_on)} a ${formatDate(h.ended_on)}`
                    : `Desde ${formatDate(h.started_on)}`}
                  {` • ${formatDuration(h.started_on, h.ended_on)}`}
                  {h.assigned_by_name ? ` • por ${h.assigned_by_name}` : ""}
                </span>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
